export const POSITIONS = {
  recruiter: 'Recruiter',
  ceo: 'CEO',
  headOfEstoniaBusiness: 'Head of Estonia Business Operations'
};
